import { useQuery } from '@tanstack/react-query';
import { getFailedCallbacksQuery } from '../apis';
import queryKeys from '../constants/queryKeys';

const useGetFailedCallbacks = ({ id, pageIndex, pageSize }) => {
  return useQuery({
    enabled: !!id,
    queryKey: queryKeys.getFailedCallbacks(id, JSON.stringify({ pageIndex, pageSize })),
    queryFn: () => getFailedCallbacksQuery(id, { pageIndex, pageSize }),
  });
};

export default useGetFailedCallbacks;
